// extracted by mini-css-extract-plugin
module.exports = {"post-comment":"PostComment_post-comment__RW_ip","comment-buttons":"PostComment_comment-buttons__Ry0Ui","border-left":"PostComment_border-left__GVdzy"};